/**
 * Native Base Header will set bar style to light-content when using material theme, we need override on every header
 */
import React, { Component } from "react";
import { Platform } from "react-native";
import { Header } from "native-base";
import FocusAwareHeader from "./FocusAwareHeader";
import _ from "lodash";
// import PropTypes from "prop-types";
import { IPhoneXHelper } from "../../theme";

/**
 * these props Header should not be override height
 */
//const CAN_NOT_OVERRIDE_HEIGHT_PROP = ["span", "hasBgImg", "searchBar", "withoutHeight", "withSearchBar", "doNotOverrideHeight"];

const isIos = Platform.OS === "ios";
//const additionProp = isIos ? { iosBarStyle: "dark-content" } : {};
const additionProp = { iosBarStyle: "dark-content" };
class WrappedHeader extends Component {
    render() {
        const extraStyle = this.getExtraStyle(this.props);
        const propsStyle = _.isArray(this.props.style) ? this.props.style[0] : this.props.style;
        const { focusAware, ...props } = this.props;
        if (focusAware) {
            return (
                <FocusAwareHeader noShadow={isIos ? true : false} androidStatusBarColor={"#ffffff"} {...additionProp} {...props} style={[propsStyle, extraStyle]}>
                    {this.props.children}
                </FocusAwareHeader>
            );
        }
        return (
            <Header noShadow={isIos ? true : false} androidStatusBarColor={"#ffffff"} {...additionProp} {...props} style={[propsStyle, extraStyle]}>
                {this.props.children}
            </Header>
        );
    }


    getExtraStyle = props => {
        var bottomColor = props.bottomColor ? props.bottomColor : "#f4f4f4";
        //var tempStyle = isIos ? {borderBottomWidth: 1, borderBottomColor: bottomColor, paddingTop: 0 } : null;
        var tempStyle = {borderBottomWidth: 1, borderBottomColor: bottomColor, paddingTop: 0 };
        const needFitHeight = IPhoneXHelper.isIphone12PRO || IPhoneXHelper.isIphone12MAX;
        //const isIphoneX = IPhoneXHelper.needFitIphoneX;

        //also if you set height in style, we do not override for you
        //const overrideHeight = !this.hasAnyProps(props, CAN_NOT_OVERRIDE_HEIGHT_PROP) && (this.props.style ? !this.props.style.hasOwnProperty("height") : true);

        //using variable for same native base height and - the status bar height 20
        //return needFitHeight ? { ...tempStyle, height: 90, paddingTop: 35 } : {...tempStyle};
        //return needFitHeight ? { ...tempStyle, height: 60, paddingTop: 0 } : {...tempStyle, height: 60, paddingTop: 0 };
        return tempStyle; //return { ...tempStyle, height: 60, paddingTop: 0 };
    };
}

WrappedHeader.propTypes = {
    ...Header.propTypes,
};
WrappedHeader.defaultValue = {
    ...Header.defaultValue,
};
export default WrappedHeader;
